// data object to be used to populate the Navigation bar-
//add a new item providing a new title and url to be used for routing and this will automatically be dislayed on the Navbar
export const NavBarMenuList = [
  
  {
    title: 'Pregnancy Tracker',
    url: '/tracker',
  },
  {
    title: 'Articles',
    url: '/articles',
  },
  {
    title: 'Recipes',
    url: '/recipes',
  },
];
